export default __webpack_public_path__ + "8e5f7eba5d7b8e5e8811f601daa0f5d7.svg";